import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { I18n as I } from 'react-redux-i18n';
import { useFormContext } from 'lib/form';

import {
  LoaderOverlay,
  isFunc,
  isObject,
  FieldInfo,
  Dropdown,
  TextArea,
  ControlTypes,
} from 'vdlib';
import LookupsHelper from 'lib/LookupsHelper';

const AuctionCancellationModal = ({
  cancellationReasonID,
  cancellationReasons,
  cancelButton,
  loading,
  onHide,
  onSubmit,
  show,
  submitButton,
  title,
}) => {
  const { formContext, formData, setFormData } = useFormContext({
    cancellationReasonID,
  });

  const cancellationReason = React.useMemo(
    () =>
      LookupsHelper.getDescription(
        cancellationReasons,
        formData.cancellationReasonID
      ),
    [cancellationReasons, formData.cancellationReasonID]
  );

  const handleSubmit = React.useCallback(() => {
    if (!cancellationReason)
      return setFormData('cancellationReasonID', formData.cancellationReasonID);
    if (isFunc(onSubmit)) onSubmit(cancellationReason);
  }, [cancellationReason, formData, onSubmit, setFormData]);

  const buttons = React.useMemo(
    () => [
      isObject(submitButton) ? (
        submitButton
      ) : (
        <button
          type="button"
          className={`btn btn-primary btn-sm float-right ml-sm ${
            loading ? 'disabled' : ''
          } `}
          disabled={loading}
          onClick={handleSubmit}
        >
          {submitButton || I.t('SAVE_INPUT')}
        </button>
      ),
      isObject(cancelButton) ? (
        cancelButton
      ) : (
        <button
          type="button"
          className={`btn btn-default btn-sm float-right ${
            loading ? 'disabled' : ''
          }`}
          disabled={loading}
          onClick={onHide}
        >
          {cancelButton || I.t('CLOSE')}
        </button>
      ),
    ],
    [formData, handleSubmit, onHide] //eslint-disable-line
  );

  const hasError = formData.dirty == true && cancellationReason == '';

  return (
    <Modal
      footer={buttons}
      title={title || I.t('CANCELLATION')}
      visible={show}
      onHide={onHide}
    >
      <LoaderOverlay loading={loading === true} />
      <br />
      <div className="row form-group">
        <label className="control-label col-3">
          {I.t('CANCELLATION_REASON')}
        </label>
        <div className={`col-9 ${hasError ? 'has-error' : ''}`}>
          <Dropdown
            value={formData.cancellationReasonID}
            field={
              new FieldInfo(
                'cancellationReasonID',
                '',
                formData.cancellationReasonID,
                cancellationReasons,
                formContext.current,
                ControlTypes.Dropdown
              )
            }
            validationMessage={hasError ? '' : ''}
          />
        </div>
        {formData.cancellationReasonID === 5 ? (
          <div>
            <br />
            <label className="control-label col-3">{I.t('DESCRIPTION')}</label>
            <br />

            <div className={`col-9 ${hasError ? 'has-error' : ''}`}>
              <TextArea
                value={cancellationReason}
                field={
                  new FieldInfo(
                    'cancellationReason',
                    '',
                    cancellationReason,
                    null,
                    formContext.current,
                    ControlTypes.Textarea
                  )
                }
                validationMessage={hasError ? '' : ''}
              />
            </div>
          </div>
        ) : (
          false
        )}
      </div>
    </Modal>
  );
};

AuctionCancellationModal.propTypes = {
  loading: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool,
  theme: PropTypes.string,
  title: PropTypes.string,
};

export default AuctionCancellationModal;
